// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__FWmoU","left":"StickyBox_left__6zFAc","right":"StickyBox_right__2bTms"};